import { IGetAllRequisicaoCompraUseCase } from "../../../presentation/useCases/read/get_all_requisicao_compra_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { RequisicaoCompraLista } from "../../models/requisicao_compra_lista";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetAllRequisicaoCompraUseCase
 */

export class GetAllRequisicaoCompraUseCase
  extends BasePaginatedUseCase<RequisicaoCompraLista>
  implements IGetAllRequisicaoCompraUseCase {
  constructor(private readonly repository: IComprasRepository) {
    super();
  }

  async getAllRequisicaoCompra(
    nroRequisicao: number | null,
    dataRequisicaoStart: Date | null,
    dataRequisicaoEnd: Date | null,
    centroCustos: number[] | null,
    solicitantes: number[] | null,
    status: number | null,
    produtoServicos: number[] | null,
    dataPrevistaStart: Date | null,
    dataPrevistaEnd: Date | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getAllRequisicaoCompra(
      nroRequisicao,
      dataRequisicaoStart,
      dataRequisicaoEnd,
      centroCustos,
      solicitantes,
      status,
      produtoServicos,
      dataPrevistaStart,
      dataPrevistaEnd,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
